import { render, staticRenderFns } from "./ClusterPopulation.vue?vue&type=template&id=22d53ca5&"
import script from "./ClusterPopulation.vue?vue&type=script&lang=js&"
export * from "./ClusterPopulation.vue?vue&type=script&lang=js&"
import style0 from "./ClusterPopulation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports